import * as React from 'react';
import type { FC } from 'react';
import type { Locales } from 'app/helpers/createLocalesContext';
import { translation } from 'app/helpers/createLocalesContext';
import type { Values, ChangeValues } from './types';

const Adult: FC<{
  values: Values;
  changeValues: ChangeValues;
  locales: Locales;
}> = ({ values, changeValues, locales }) => (
  <div className="input boolean player_adult xo-form_input-checkbox">
    <input
      type="checkbox"
      checked={values.adult}
      onChange={() => changeValues({ adult: !values.adult })}
      name="player[adult]"
      id="player_adult"
    />
    <label htmlFor="player_adult">
      {translation(locales, values.country === 'EE' ? 'attributes.adult_ee' : 'attributes.adult')}
    </label>
  </div>
);

export default Adult;
